<div class="topline">
  <h2>Co-branding</h2>
  <div class="actions">
    <button mat-raised-button color="primary" (click)="addCobranding()">Add Co-branding</button>
  </div>
</div>

<div class="scroll-container">
  <table mat-table [dataSource]="partners" class="table">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let partner">{{partner.name}}</td>
    </ng-container>

    <ng-container matColumnDef="colors">
      <th mat-header-cell *matHeaderCellDef>Colors</th>
      <td mat-cell *matCellDef="let partner">
        <div class="colors">
          <span class="color" [style.backgroundColor]="partner.ourlyPrimaryColor"></span>
          <span class="color" [style.backgroundColor]="partner.ourlySecondaryColor"></span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="url">
      <th mat-header-cell *matHeaderCellDef>URL</th>
      <td mat-cell *matCellDef="let partner">
        <button class="link" type="button" (click)="openUrl(partner.redirectUrl)">{{partner.redirectUrl}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="logo">
      <th mat-header-cell *matHeaderCellDef>Logo</th>
      <td mat-cell *matCellDef="let partner">
        <img *ngIf="partner.logoUrl" [src]="partner.logoUrl" class="logo" alt="logo">
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let partner">
        <button mat-icon-button [matMenuTriggerFor]="actionsMenu" [matMenuTriggerData]="{partner: partner}">
          <mat-icon>more_vert</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['name','colors','url','logo','actions']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['name','colors','url','logo','actions']"></tr>
  </table>

  <div class="loading" *ngIf="loading">Loading...</div>
  <div class="empty" *ngIf="!loading && partners.length === 0">There are no items to show.</div>
</div>

<mat-menu #actionsMenu="matMenu">
  <ng-template matMenuContent let-partner="partner">
    <button mat-menu-item (click)="editCobranding(partner)">Modify Co-branding</button>
    <button mat-menu-item (click)="clone(partner)">Clone</button>
    <button mat-menu-item (click)="deleteCobranding(partner)">Delete</button>
  </ng-template>
</mat-menu>
